import { useState } from "react";
import Darkmode from "./Darkmode";

const Navbar = () => {
  const [isMobMenu, setIsMobMenu] = useState(false);

  const toggleMobMenu = () => {
    setIsMobMenu(!isMobMenu);
  };

  const handleLinkClick = (e, href) => {
    e.preventDefault();
    const targetElement = document.querySelector(href);
    if (targetElement) {
      const offset = -85;
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY + offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
    setIsMobMenu(false);
  };

  // const navLinks = ["#home", "#bio", "#skills", "#experience", "#projects", "#contact"];
  const navLinks = ["#home", "#bio", "#skills", "#projects", "#contact"];

  return (
    <nav className="fixed left-0 right-0 top-0 z-50 w-full m-0 p-0">
      {/* Desktop Navbar */}
      <div className="mx-auto hidden max-w-5xl items-center justify-between rounded-full border border-stone-200/50 dark:border-stone-700/50 bg-white/80 dark:bg-stone-800/80 py-3 px-8 backdrop-blur-md lg:flex mt-6 shadow-sm transition-colors duration-300">
        {/* Logo Section */}
        <div className="flex items-center">
          <a href="#home" onClick={(e) => handleLinkClick(e, "#home")} className="text-2xl font-bold tracking-widest text-stone-900 dark:text-stone-100 hover:text-stone-600 dark:hover:text-stone-300 transition-colors">
            <img src="/s_logo.png" alt="Logo" className="h-10 w-auto" />
          </a>
        </div>

        {/* Navigation Links */}
        <div className="flex items-center gap-8">
          {navLinks.map((link, index) => (
            <a
              key={index}
              href={link}
              className="text-stone-800 dark:text-stone-300 hover:text-stone-900 dark:hover:text-stone-100 transition-colors text-base font-medium uppercase tracking-wider"
              onClick={(e) => handleLinkClick(e, link)}
            >
              {link.replace("#", "")}
            </a>
          ))}
          <Darkmode />
        </div>
      </div>

      {/* Mobile Navbar */}
      <div className="lg:hidden fixed w-full bg-white/95 dark:bg-stone-900/95 py-4 px-6 backdrop-blur-md z-50 top-0 border-b border-stone-200/50 dark:border-stone-800/50 shadow-sm">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <a href="#home" onClick={(e) => handleLinkClick(e, "#home")} className="text-2xl font-bold tracking-widest text-stone-900 dark:text-stone-100">
              <img src="/s_logo.png" alt="Logo" className="h-10 w-auto" />
            </a>
          </div>

          <div className="flex items-center gap-4">
            <Darkmode />
            {/* Mobile Menu Toggle */}
            <button
              aria-label="Toggle Menu"
              className="text-stone-900 dark:text-stone-100 focus:outline-none text-3xl font-bold"
              onClick={toggleMobMenu}
            >
              {isMobMenu ? "✕" : "☰"}
            </button>
          </div>
        </div>

        {/* Mobile Menu Links */}
        {isMobMenu && (
          <div className="mt-6 flex flex-col items-center gap-6 pb-4">
            {navLinks.map((link, index) => (
              <a
                key={index}
                href={link}
                className="text-stone-800 dark:text-stone-300 hover:text-stone-900 dark:hover:text-stone-100 transition-colors text-xl font-medium uppercase tracking-widest"
                onClick={(e) => handleLinkClick(e, link)}
              >
                {link.replace("#", "")}
              </a>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
